import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GenerateSmartLockChallengeResData } from "./GenerateSmartLockChallengeResData";

const ENDPOINT = "/otc/smartlock/challenge/generate";

export class GenerateSmartLockChallengeCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GenerateSmartLockChallengeReqData;

    constructor(installationName: string, serialNumber: string, nonce: string) {
        super();
        this.payload = new GenerateSmartLockChallengeReqData(installationName, serialNumber, nonce);
    }

    public async execute(): Promise<GenerateSmartLockChallengeResData> {
        let res = await this.executeCommand(this.payload);
        return new GenerateSmartLockChallengeResData(res);
    }
}

export class GenerateSmartLockChallengeReqData {
    installationName: string;
    serialNumber: string;
    nonce: string;

    constructor(installationName: string, serialNumber: string, nonce: string) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.nonce = nonce;
    }
}
